import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

import { initialize } from './authenticationReducer';
import authenticationSelector from './authenticationSelector';
import type { AppDispatch } from '../store';
import validate from '../common/helpers/validate';
import PasswordField from '../common/components/PasswordField';
import encryption from '../common/helpers/encryption';
import transformer from '../common/helpers/transformer';

function InitLogin() {
  const dispatch: AppDispatch = useDispatch();

  const isInitLoading = useSelector(authenticationSelector.isInitLoading);
  const [password, setPassword] = React.useState<string>('');
  const [passwordRepetition, setPasswordRepetition] = React.useState<string>('');
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);

  const authenticate = async () => {
    try {
      const passwordValidation = validate.validatePassword(password, passwordRepetition);
      setErrorMessage(passwordValidation);
      if (passwordValidation == null) {
        const { key, salt } = await encryption.initKeys(password);
        await dispatch(
          initialize({
            password: transformer.fromUint8ArrayToBase64(key),
            salt: transformer.fromUint8ArrayToBase64(salt),
          })
        );
      }
    } catch (error) {
      // TODO
      console.log(error);
    }
  };

  return (
    <>
      <Typography fontSize='1.5rem' mb={2}>
        Passwort initialisieren
      </Typography>
      <Stack direction='column' spacing={1} mb={2} maxWidth='300px'>
        <PasswordField
          fullWidth
          autoFocus
          value={password}
          handleChange={setPassword}
          onKeyPress={async (keyEvent) => {
            if (keyEvent.key === 'Enter') {
              await authenticate();
            }
          }}
        />
        <PasswordField
          fullWidth
          error={errorMessage != null}
          helperText={errorMessage}
          value={passwordRepetition}
          handleChange={setPasswordRepetition}
          onKeyPress={async (keyEvent) => {
            if (keyEvent.key === 'Enter') {
              await authenticate();
            }
          }}
        />
      </Stack>
      <Button
        variant='contained'
        startIcon={isInitLoading ? <CircularProgress /> : null}
        disabled={isInitLoading}
        onClick={async () => await authenticate()}
        sx={{ marginTop: '16px', marginLeft: 'auto' }}
      >
        Initialisieren
      </Button>
    </>
  );
}

export default InitLogin;
